import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class GuardService extends BaseDataService {

    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getGuardEmployees(accountId: number, siteId: number): Observable<any> {
        let url = `Guard/GetGuardEmployees?accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getAllGuards(accountId: number, siteId: number): Observable<any> {
        let url = `Guard/GetAll?accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getAllGuardsByDayAndAccount(date: string, accountId: number, siteId: number) {
        let url = `Guard/GetAllGuardsPerDayAndAccount?date=${date}&accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }
    public getAllGuardsByDayAccountAndSiteId(date: string, accountId: number, siteId: number) {
        let url = `Guard/GetAllGuardsByDayAccountAndSiteId?date=${date}&accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getGuard(id?: number): Observable<any> {
        let url = `Guard/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public getByName(name: string, siteId: number): Observable<any> {
        let url = `Guard/GetByName?name=${name}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getGuardEmployee(id?: number): Observable<any> {
        let url = `Guard/GetGuardEmployee?id=${id}`;
        return super.getAll<any>(url);
    }

    public saveGuard(data) {
        let url = `Guard/Save`;
        return super.save<any>(url, data);
    }

    public saveGuardEmployee(data) {
        let url = `Guard/SaveGuardEmployee`;
        return super.save<any>(url, data);
    }
    public deleteGuard(data) {
        let url = `Guard/Delete?id=${data}`;
        return super.save<any>(url, data);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/guard.service.ts